import { PaginationValues } from "../../types/General/PaginationValues";
import { Indicator } from "../../types/Indicator/Indicator";
import { IndicatorHistory } from "../../types/Indicator/IndicatorDataReport/IndicatorHistory";
import api from "../../utils/api";
import { INDICATOR_REGION_HISTORY_URL } from "../../utils/endpoints";

export async function getIndicatorRegionHistory(
  params: any,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(
      `${INDICATOR_REGION_HISTORY_URL}?IndicatorId=${params.IndicatorId}&FrequencyId=${params.FrequencyId}&Province=${params.ProvinceId}&CountyId=${params.CountyId}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );

    const data: IndicatorHistory[] = response.data.result.result.map(
      (option: IndicatorHistory) => ({
        datas: option.datas,
        year: option.year,
      }),
    );

    const indicator: Indicator = {
      id: response.data.indicator.id,
      name: response.data.indicator.name,
      type: response.data.indicator.type,
      subSystem: response.data.indicator.subSystem,
      frequency: response.data.indicator.frequency,
      readingVariation: response.data.indicator.readingVariation,
      level: response.data.indicator.level,
      alertState: response.data.indicator.alertState ?? null,
      reference: response.data.indicator.reference ?? null,
      partner: response.data.indicator.partner,
      collectionType: response.data.indicator.collectionType,
      metric: response.data.indicator.metric,
      anotherMetric: response.data.indicator.anotherMetric ?? null,
      state: response.data.indicator.state ?? null,
    };

    return {
      content: data,
      totalItems: response.data.result.totalItems,
      indicator: indicator,
    };
  } catch (error) {
    throw error;
  }
}
